import { EmployeeDependentDTO } from "../../models/employee-dependents";
import { EmployeeDependentMutationDTO } from "../../models/employee-dependents/mutations/employee-dependent-mutation-dto";
import { EmployeeDependentMutationSTO } from "../../models/employee-dependents/mutations/employee-dependent-mutation-sto";
import { EmployeeDependentMutationsFilter } from "../../models/employee-dependents/mutations/employee-dependent-mutations-filter";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeCurrentDependentsMutationsApiService extends BaseApiService<
  EmployeeDependentMutationDTO,
  EmployeeDependentMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeDependentMutations",
      loadItemsPath: "/GetCurrentEmployeeDependentMutations",
      saveItemsPath: "/SaveCurrentEmployeeDependentMutations",
    });
  }
}

export const loadEmployeeDependentMutations = async (
  employeeId: string,
  dependents: EmployeeDependentDTO[],
  signal?: AbortSignal
) => {
  const dependentIds = dependents.map((d) => d.id);

  const employeesDependentMutationsApiService = new EmployeeCurrentDependentsMutationsApiService();
  const response = await employeesDependentMutationsApiService.loadItems(
    { employeeId, dependentIds } as EmployeeDependentMutationsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export const saveEmployeeDependentMutations = async (employeeDependentMutation: EmployeeDependentMutationSTO) => {
  const response = await new EmployeeCurrentDependentsMutationsApiService().saveItems([employeeDependentMutation]);

  toastifyResponse(response, "all", "default_success_message", "failure_saving_data", "error_saving_data");

  return response;
};
